import i18n from "../i18n";
import {
  ACTIVITY_UNITS,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  BARCODE_READ,
  BARCODE_READ_IMG,
  CLEAR_SYMPTOM,
  CREATE_SYMPTOM,
  DISMISS_SAVE_SUCCESS,
  DRUG_UNITS,
  FOOD_UNITS,
  GET_SYMPTOM_USERS,
  getEnded,
  getFailed,
  getStarted,
  getSucceeded,
  HISTORY_SUGGESTIONS_CLEAR,
  HISTORY_SUGGESTIONS_FAILED,
  HISTORY_SUGGESTIONS_STARTED,
  HISTORY_SUGGESTIONS_SUCCESS,
  INPUT_ADD_ITEM,
  IS_UNSAVED,
  LOC_UNITS,
  ON_CHANGE_ALERT_STATUS,
  ON_CHANGE_SYMPTOMFORM,
  PARTIAL_RESULT_FOUND,
  PCP_UNITS,
  RESET_CONTRIBUTE_ALERT_STATE,
  RESET_INPUT_PAGE,
  SAVE_FOOD_AND_SYMPTOMS,
  SEARCH_SYMPTOM_OPTIONS,
  SET_HHMM_MODE,
  SUP_UNITS,
  SYMPTOM_CATEGORY_SELECTED,
  SYMPTOM_DATE_CHANGED,
  SYMPTOM_FROM_BODYMAP,
  SYMPTOM_KIT_ADD,
  SYMPTOM_KIT_SELECTED,
  SYMPTOM_OPTION_SELECTED,
  SYMPTOM_UNITS_NEW,
  SYMPTOM_USER_SELECTED,
  SYMPTOMS_ITEM_DELETE,
  SYMPTOMS_ITEM_SELECT,
  SYMPTOMS_ITEM_UPDATE,
  UPDATE_ITEM_CANCELED,
} from "../actions/constant";
import { uuidv4 } from "../services/PublicService";
import _ from "lodash";
import moment from "moment";
import {
  handleUnitDropdown,
  isContributedItem,
  convertHHMMForBackend,
  convertHHMMForDisplay,
  detectItemChanged
} from "../lib/helper";

const initialState = {
  isLoading: false,
  users: [],
  nameOptions: [],
  kitdata: [],
  nameTotalOptions: [],
  measurementOptions: [],
  categories: [],
  disabled: {
    category: true,
    input: true,
    scale: true,
    name: true,
    time: true,
    addBtn: true,
    saveBtn: true,
    clearBtn: true,
    unit: true,
    comment: true,
  },
  classNames: {
    UsersBox: "",
    nameField: "",
  },
  scaleOptions: [],
  unitOptions: [],
  symptomForm: { users: [] },
  showList: [],
  deleteMode: false,
  updateMode: false,
  cancelMode: false,
  selectedItem: {},
  amountReseter: false,
  amounNewValue: null,
  counterState: 0,
  selectedIndexList: [],
  updatedList: false,
  outOfRange: false,
  upc404: false,
  upc404Value: "",
  category404Value: "",
  barcodeScanned: false,
  barcodeCategory: false,
  duplicate: false,
  barcodeRead: false,
  selectedNewTAS: false,
  itemChanged: false,
  partialResult: [],
  barcodeValue: "",
  addCustomAlert: false,
  hhmmMode: false,
  NewTrendFound: false,
  saveSuccess: false, 
  saveError: { type: null, meta: [] },
};

function reducer(state = initialState, action) {
  function userSelected(_id, single = false) {
    let symptom = state.symptomForm;
    symptom.users = [];
    let data = state.users.map((item) => {
      if (single) {
        item.isSelected = false;
        if (item._id === _id) {
          item.isSelected = true;
        }
      } else {
        if (item._id === _id) {
          if (!item.isSelected) item.isSelected = true;
          else item.isSelected = false;
        }
      }

      if (item.isSelected) {
        symptom.users.push(item._id);
      }
      return item;
    });
    state.symptomForm = symptom;
    state.users = data;
  }

  function itemSelected(showList) {
    let selectedItem = {};
    showList.map((list) => {
      if (list.inputs.length) {
        list.inputs.map((input) => {
          if (input.selected) {
            selectedItem = {
              vId: input.vId,
              name: input.name,
              scale: input.scale,
              symptom: input.symptom,
              type: "",
              category: input.category,
              time: input.time,
              comment: input.comment,
              unit: input.unit,
              users: input.users,
              completeItem: input.user,
              displayname: input.displayname,
            };
          }
        });
      }
    });
    return selectedItem;
  }

  function isZeroEquivalent(scale) {
    if (!scale || typeof scale !== "string") return true; // covers "", null, undefined

    const trimmed = scale.trim();

    // Zero equivalent HH:MM format
    const isZeroTimeFormat = /^0{1,2};0{1,2}$/.test(trimmed);
    if (isZeroTimeFormat) return true;

    // Matches 0, 0., 0.0, 000, 000.000, 0/2 etc. but NOT 0 0, 0/ or 0&1
    // const zeroEquivalentPattern = /^(?:[0.]*0+(?:\s*\/\s*[1-9]\d*)?|(?:[0.]*0+\s*(?:[& ]+\s*0+)+\s*\/\s*[1-9]\d*))$/;
    const zeroEquivalentPattern = /^(?:0*\.?0*\.?|0*(?:[& ]+0+)*\s*\/\s*[1-9]\d*)$/
    return zeroEquivalentPattern.test(trimmed);
  }

  /**
   * buttonsChecker()
   *
   * This function determines the enable/disable state of buttons and input fields based on the current symptom form state.
   *
   * ⚠️ Important:
   * The logic is intentionally structured using sequential `if` blocks rather than nested `if-else` blocks,
   * and relies heavily on the order of execution. Changing the sequence of conditions, especially for
   * scenarios like regimen items or item selection (update/cancel mode toggling), may result in regressions.
   *
   * Be cautious when refactoring this function. Each block may override or depend on the state set by earlier blocks.
   * Always test thoroughly after modifying the order or adding new conditions.
   */
  function buttonsChecker() {
    // Criteria to enable Category field
    if (state.symptomForm.users && state.symptomForm.users.length > 0) {
      state.disabled.category = false;
      state.classNames.UsersBox = "";
    } else {
      state.disabled.category = true;
      state.disabled.name = true;
      state.disabled.time = true;
      state.disabled.comment = true;
      state.classNames.UsersBox = "blinking";
    }

    // Criteria to enable Item Name field
    if (
      !state.disabled.category &&
      state.symptomForm.category &&
      state.symptomForm.category != "null"
    ) {
      state.disabled.name = false;
    } else {
      state.disabled.name = true;
    }

    // Criteria to enable Amount, Occurrence Time and Note fields for non-regimen items
    if (
      !state.disabled.name &&
      state.symptomForm.name &&
      state.symptomForm.name.trim().length > 0
    ) {
      state.disabled.scale = false;
      state.disabled.time = false;
      state.disabled.comment = false;
    } else {
      state.disabled.scale = true;
      state.disabled.time = true;
      state.disabled.comment = true;
    }

    // Criteria to enable Unit field for non-regimen items
    if (
      !state.disabled.name &&
      state.symptomForm.name &&
      state.symptomForm.name.trim().length > 0 &&
      state.unitOptions &&
      state.unitOptions.length > 1
    ) {
      state.disabled.unit = false;
    } else {
      state.disabled.unit = true;
    }

    // Criteria to enable Add Item button for non regimen items
    if (
      state.symptomForm.users &&
      state.symptomForm.users.length > 0 &&
      state.symptomForm.category &&
      state.symptomForm.category !== "null" &&
      state.symptomForm.name &&
      state.symptomForm.name.trim().length > 0 &&
      state.symptomForm.scale &&
      state.symptomForm.scale !== "null" &&
      state.symptomForm.unit &&
      state.symptomForm.unit !== "null" &&
      state.symptomForm.time
    ) {
      state.disabled.addBtn = false;
    } else {
      state.disabled.addBtn = true;
    }

    // Clear existing alert to avoid stale data
    localStorage.removeItem("unsavedAlertData");

    // Criteria to enable Save Page button and trigger Unsaved Data prompt
    if (state.showList.length > 0) {
      let logOutPrompt = { page: "input" };

      // ✅ Always re-create unsavedAlertData freshly
      localStorage.setItem("unsavedAlertData", JSON.stringify(logOutPrompt));
      state.updatedList = true;
      IS_UNSAVED("yes");
      state.disabled.saveBtn = false;
    } else {
      state.updatedList = false;
      IS_UNSAVED("no");
      state.disabled.saveBtn = true;
    }

    // Criteria to enable Clear Page button
    if (
      (state.symptomForm.category && state.symptomForm.category !== "null") ||
      state.showList.length > 0
    ) {
      state.disabled.clearBtn = false;
    } else {
      state.disabled.clearBtn = true;
    }

    // Handle zero equivalent value for Non-Symptom categories
    const scaleVal = state.symptomForm.scale;

    if (
      !state.disabled.addBtn &&
      state.symptomForm.category !== "01" &&
      isZeroEquivalent(scaleVal)
    ) {
      state.disabled.addBtn = true;
      state.cancelMode = true;
    }

    // Criteria to enable Add Item button for regimen items
    if (state.symptomForm.kitdata && state.symptomForm.kitdata.length > 0) {
      state.disabled.scale = true;
      state.disabled.unit = true;

      if (state.symptomForm.users && state.symptomForm.users.length > 0) {
        state.disabled.addBtn = false;
        state.cancelMode = false;
      } else {
        state.disabled.addBtn = true;
        state.cancelMode = false;
      }
    }

    // Criteria to enable Update Item button
    if (
      state.selectedItem &&
      (state.selectedItem.name || state.selectedItem.id || state.selectedItem.vId)
    ) {
      state.cancelMode = true;
      state.updateMode = false;
      state.disabled.addBtn = true;

      const isRegimen =
        state.symptomForm.kitdata &&
        state.symptomForm.kitdata.length > 0;

      // Overlapping required fields for both regimen and non-regimen
      const hasRequiredFields =
        state.symptomForm.users &&
        state.symptomForm.users.length > 0 &&
        state.symptomForm.category &&
        state.symptomForm.category !== "null" &&
        state.symptomForm.name &&
        state.symptomForm.name.trim().length > 0 &&
        !!state.symptomForm.time;

      if (state.itemChanged) {
        if (
          !isRegimen &&
          hasRequiredFields &&
          state.symptomForm.scale &&
          state.symptomForm.scale.trim() !== "null" &&
          state.symptomForm.unit &&
          state.symptomForm.unit.trim() !== "null"
        ) {
          if (state.symptomForm.category !== "01" &&
            isZeroEquivalent(scaleVal)
          ) {
            state.cancelMode = true;
            state.updateMode = false;
            state.disabled.addBtn = true;
          } else {
            state.cancelMode = false;
            state.updateMode = true;
            state.disabled.addBtn = false;
          }
        } else if (
          isRegimen &&
          hasRequiredFields
        ) {
          state.cancelMode = false;
          state.updateMode = true;
          state.disabled.addBtn = false;
        } else {
          // Incomplete form even with changes made
          state.cancelMode = true;
          state.updateMode = false;
          state.disabled.addBtn = true;
        }
      }
    } else {
      state.cancelMode = false;
      state.updateMode = false;
    }

    state.counterState = state.counterState + 1;
  }

  function foodunits() {
    let funits = [];
    funits = FOOD_UNITS().map((e) => {
      return {
        label: e.unit,
        value: e._id,
      };
    });
    return funits;
  }

  switch (action.type) {
    case getStarted(GET_SYMPTOM_USERS):
      IS_UNSAVED("no");
      return { ...state, isLoading: true };
    case getSucceeded(GET_SYMPTOM_USERS):
      let data = [action.payload.users];
      let defaultData = localStorage.getItem("contDefault");
      let defaultVal = JSON.parse(defaultData);

      if (action.payload.users.sub_users) {
        data = [action.payload.users, ...action.payload.users.sub_users];
      }
      if (data && data.length > 0) {
        if (data.length == 1) {
          data[0].isSelected = true;
          state.symptomForm.users = [data[0]._id];
          state.symptomForm.category = "02";
        } else {
          state.classNames.UsersBox = "blinking";
        }
      }
      if (defaultData) {
        symptomForm = {
          ...state.symptomForm,
          _id: defaultVal._id || "",
          name: defaultVal.fullname || defaultVal.name,
          sName: defaultVal.sName || defaultVal.name,
          scale: defaultVal.scale,
          symptom: defaultVal._id || "",
          comment: defaultVal.comment || state.symptomForm.comment,
          category: defaultVal.category,
          time: defaultVal.time !== "" ? moment(defaultVal.time) : moment(),
          unit: state.symptomForm.category === "01" ? "142" : "",
          users: defaultVal.users,
          upc: defaultVal.upc,
          unitList: defaultVal.unitList,
          fullname: defaultVal.fullname,
          displayname: defaultVal.name,
        };
        state.showList = defaultVal.showList;
        state.selectedItem = itemSelected(defaultVal.showList);
        state.symptomForm.kitdata = {};
        state.symptomForm.ingredients = "";
        state.kitdata = [];
        state.scaleOptions = [];

        state.symptomForm.unitList = [];
        let units = [];

        if (defaultVal.unitList.length > 0) {
          units = defaultVal.unitList;
        } else {
          if (defaultVal.category == "02") {
            units = foodunits();
          } else if (defaultVal.category == "01") {
            units = [
              { value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") },
            ];
          } else if (defaultVal.category == "03") {
            let act_units = ACTIVITY_UNITS();
            act_units.map((item) => {
              if (item._id == "103") {
                return false;
              } else if (item._id == "104") {
                return false;
              } else {
                units.push({ value: item._id, label: item.unit });
              }
            });
          } else if (defaultVal.category == "04") {
            let act_units = PCP_UNITS();
            units = act_units.map((item) => {
              return { value: item._id, label: item.unit };
            });
          } else if (defaultVal.category == "05") {
            let act_units = DRUG_UNITS();
            units = act_units.map((item) => {
              return { value: item._id, label: item.unit };
            });
          } else if (defaultVal.category == "06") {
            let act_units = SUP_UNITS();
            units = act_units.map((item) => {
              return { value: item._id, label: item.unit };
            });
          } else if (defaultVal.category == "07") {
            let act_units = LOC_UNITS();
            units = act_units.map((item) => {
              return { value: item._id, label: item.unit };
            });
          }
        }

        state.unitOptions = units;
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";
        state.symptomForm = symptomForm;
        defaultData = {};
      }
      state.categories = action.payload.categories;
      state.users = defaultVal ? defaultVal.userList : data;
      if (
        defaultVal &&
        defaultVal.users &&
        defaultVal.users.length > 0 &&
        state.users.length > 0 &&
        state.selectedItem.vId
      ) {
        for (let index = 0; index < state.users.length; index++) {
          const useId = state.users[index];
          userSelected(useId);
        }
        state.updateMode = true;
        state.cancelMode = true;
      }
      buttonsChecker();
      if (!localStorage.getItem("unContributed")) {
        localStorage.removeItem("contDefault");
      }
      return {
        ...state,
        isLoading: false,
        selectedNewTAS: false,
      };

    case SYMPTOM_USER_SELECTED:
      let u_id = action.data._id;

      const isCategoryEmpty =
        !state.symptomForm.category || state.symptomForm.category.trim() === "";
      const noUserPreviouslySelected = state.symptomForm.users.length === 0;

      userSelected(u_id);

      // When at least 1 user is selected, if the Category was previously blank, toggle it to Food. Otherwise, no changes required for category.  
      if (noUserPreviouslySelected && isCategoryEmpty) {
        state.symptomForm = {
          ...state.symptomForm,
          category: "02",
        };
      }

      buttonsChecker();

      return {
        ...state,
        isLoading: false,
        selectedNewTAS: false,
        symptomForm: {
          ...state.symptomForm, // trigger re-render
        },
      };
    case SYMPTOM_CATEGORY_SELECTED:
      state.unitOptions = [];
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";

      const preservedName = state.symptomForm.name || "";
      const hasPreservedName = preservedName.trim().length > 0;
      const newCategory = action.value;

      symptomForm = {
        name: preservedName,      // ✅ keep typed keyword
        scale: "",
        symptom: "",              // ✅ clear selected DB id
        type: "",
        comment: "",
        category: newCategory,
        time: hasPreservedName ? moment() : "",   // ✅ show current time immediately,
        unit: newCategory === "01" && hasPreservedName ? "142" : "", // ✅ auto unit for symptom,
        users: state.symptomForm.users,
      };
      state.symptomForm = symptomForm;
      state.nameOptions = [];

      // ✅ bootstrap unit dropdown like SEARCH_SYMPTOM_OPTIONS
      if (hasPreservedName) {
        state.unitOptions =
          newCategory === "01"
            ? [] // symptom unit is fixed, so field stays disabled by design
            : handleUnitDropdown(newCategory, { unit: [] }, true);
      } else {
        state.unitOptions = [];
      }

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      state.itemChanged = detectItemChanged(state.symptomForm, state.selectedItem);

      buttonsChecker();
      return { ...state, isLoading: false, selectedNewTAS: false };
    case ON_CHANGE_SYMPTOMFORM:
      state.symptomForm[action.event.target.name] = action.event.target.value;

      if (state.symptomForm.unit !== "") {
        let sunits;
        if (state.symptomForm.category === "01") {
          sunits = SYMPTOM_UNITS_NEW();
        } else if (state.symptomForm.category === "02") {
          sunits = FOOD_UNITS();
        } else if (state.symptomForm.category === "04") {
          sunits = PCP_UNITS();
        } else if (state.symptomForm.category === "05") {
          sunits = DRUG_UNITS();
        } else if (state.symptomForm.category === "06") {
          sunits = SUP_UNITS();
        } else if (state.symptomForm.category === "03") {
          sunits = ACTIVITY_UNITS();
        } else if (state.symptomForm.category === "07") {
          sunits = LOC_UNITS();
        }
        let scalList = [];
        for (const sunit of sunits) {
          if (state.symptomForm.unit === sunit._id) {
            if (sunit.label) {
              for (let index = 0; index < sunit.value.length; index++) {
                scalList.push({
                  value: sunit.value[index],
                  label: sunit.label[index],
                });
              }
            } else {
              if (sunit.description) {
                scalList.desc = sunit.description;
                scalList.min = sunit.value[0];
                scalList.max = sunit.value[1];
              }
            }
          }
        }
        state.scaleOptions = scalList;

        // Checking for the allowed number range
        let scaleValue = state.symptomForm.scale.trim();
        let parsedValue = NaN;

        // Check for mixed fraction: "1 & 1/2" or "1 1/2"
        let mixedFraction = scaleValue.match(/^(\d+)\s*[& ]\s*(\d+)\/(\d+)$/);
        if (mixedFraction) {
          const whole = parseInt(mixedFraction[1], 10);
          const numerator = parseInt(mixedFraction[2], 10);
          const denominator = parseInt(mixedFraction[3], 10);
          parsedValue = whole + numerator / denominator;
        } else {
          // Check for pure fraction: "1/2"
          let simpleFraction = scaleValue.match(/^(\d+)\/(\d+)$/);
          if (simpleFraction) {
            const numerator = parseInt(simpleFraction[1], 10);
            const denominator = parseInt(simpleFraction[2], 10);
            parsedValue = numerator / denominator;
          } else {
            // Try parsing as a float (normal number)
            parsedValue = parseFloat(scaleValue);
          }
        }

        // Flag for "Value too Small or Too Large" prompt
        if (!isNaN(parsedValue) && (parsedValue < scalList.min || parsedValue > scalList.max)) {
          const cleanedNewName = (state.symptomForm.name || "").trim().toLowerCase().replace(/\(c\)$/i, "").trim();
          const cleanedOriginalName = (state.selectedItem.name || "").trim().toLowerCase().replace(/\(c\)$/i, "").trim();

          let hasNameChanged;
          if (state.selectedItem.id) {
            hasNameChanged = !state.symptomForm.symptom || state.selectedItem.id !== state.symptomForm.symptom;
          } else if (state.selectedItem.upc) {
            hasNameChanged = !state.symptomForm.upc || state.selectedItem.upc !== state.symptomForm.upc;
          } else {
            hasNameChanged = cleanedNewName !== cleanedOriginalName;
          }

          const categoryChanged = (state.symptomForm.category || "").toString() !== (state.selectedItem.category || "").toString();
          const unitChanged = (state.symptomForm.unit || "").toString() !== (state.selectedItem.unit || "").toString();
          const scaleChanged = (state.symptomForm.scale || "").toString().trim() !== (state.selectedItem.scale || "").toString().trim();

          if (hasNameChanged || categoryChanged || unitChanged || scaleChanged) {
            state.outOfRange = true;
          } else {
            state.outOfRange = false;
          }
        } else {
          state.outOfRange = false;
        }
      }

      state.itemChanged = detectItemChanged(state.symptomForm, state.selectedItem);

      const prev = state.symptomFormPrevious || {};
      const current = state.symptomForm;

      const unitChangedToNonHHMM = prev.unit === "445" && current.unit !== "445";
      const unitChangedToHHMM = prev.unit !== "445" && current.unit === "445";

      // Deactivate hhmmMode if user changes unit away from 445
      if (unitChangedToNonHHMM) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
        state.symptomForm.scale = "";
        state.amounNewValue = "";
      }

      // Activate hhmmMode if user manually selects 445 (HH:MM unit)
      if (unitChangedToHHMM) {
        state.hhmmMode = true;
        state.amountReseter = !state.amountReseter;
        state.symptomForm.scale = "";
        state.amounNewValue = "";
      }

      // ✅ Update the stored previous values at the end
      state.symptomFormPrevious = {
        name: current.name || "",
        category: current.category || "",
        unit: current.unit || ""
      };

      buttonsChecker();

      return {
        ...state,
      };
    case CLEAR_SYMPTOM:
      if (action.action === "Yes") {
        symptomForm = {
          ...state.symptomForm,
        };
        state.symptomForm = symptomForm;
      } else if (action.action === "Cancel") {
        symptomForm = {
          ...state.symptomForm,
          upc: "",
        };
        state.symptomForm = symptomForm;
      } else {
        state.itemInVerAutofill = false;
        data = state.users.map((item) => {
          delete item.inputs;
          return item;
        });
        let symptomForm = {
          name: "",
          scale: "",
          symptom: "",
          type: "",
          comment: "",
          category: "",
          time: "",
          unit: "",
          users: state.symptomForm.users,
        };
        state.symptomForm = symptomForm;
        state.selectedItem = {};
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";
        state.showList = [];
        state.unitOptions = [];

        // Toggle checkboxes in UI based on users in symptomForm
        state.users = state.users.map(user => ({
          ...user,
          isSelected: Array.isArray(symptomForm.users)
            ? symptomForm.users.includes(user._id)
            : false,
        }));

        if (state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter;
        }

        buttonsChecker();
        localStorage.removeItem("contDefault");
        localStorage.removeItem("unContributed");
      }
      return {
        ...state,
        nameOptions: [],
        deleteMode: false,
        updateMode: false,
        selectedNewTAS: false,
        saveSuccess: false,
        NewTrendFound: false,
        saveError: { type: null, meta: [] },
      };
    case SEARCH_SYMPTOM_OPTIONS:
      state.partialResult = [];
      state.itemInVerAutofill = false;
      let symptomForm = { ...state.symptomForm };
      // Check C
      let goSearch = true;
      let itemName = action.val;
      let itemSname = state.symptomForm.sName;
      let itemID = state.symptomForm.symptom
        ? state.symptomForm.symptom.slice(0, 1)
        : "";

      // End Check C
      if (goSearch) {
        state.symptomForm.kitdata = {};
        state.symptomForm.ingredients = "";
        state.kitdata = [];
        if (!isContributedItem(state.symptomForm)) {
          state.symptomForm.symptom = "";
        }
        state.scaleOptions = [];

        state.symptomForm.unitList =
          !action.crossClicked &&
            state.symptomForm.unitList &&
            state.symptomForm.unitList.length > 0
            ? state.symptomForm.unitList
            : [];
        let units = [];
        if (state.symptomForm.category == "02") {
          units = foodunits();
          units =
            !action.crossClicked &&
              state.symptomForm.unitList &&
              state.symptomForm.unitList.length > 0
              ? state.symptomForm.unitList
              : units;
        } else if (state.symptomForm.category == "01") {
          units = [{ value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") }];
        } else if (state.symptomForm.category == "03") {
          let act_units = ACTIVITY_UNITS();
          act_units.map((item) => {
            if (item._id == "103") {
              return false;
            } else if (item._id == "104") {
              return false;
            } else {
              units.push({ value: item._id, label: item.unit });
            }
          });
        } else if (state.symptomForm.category == "04") {
          let act_units = PCP_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
          units =
            !action.crossClicked &&
              state.symptomForm.unitList &&
              state.symptomForm.unitList.length > 0
              ? state.symptomForm.unitList
              : units;
        } else if (state.symptomForm.category == "05") {
          let act_units = DRUG_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
          units =
            !action.crossClicked &&
              state.symptomForm.unitList &&
              state.symptomForm.unitList.length > 0
              ? state.symptomForm.unitList
              : units;
        } else if (state.symptomForm.category == "06") {
          let act_units = SUP_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
          units =
            !action.crossClicked &&
              state.symptomForm.unitList &&
              state.symptomForm.unitList.length > 0
              ? state.symptomForm.unitList
              : units;
        } else if (state.symptomForm.category == "07") {
          let act_units = LOC_UNITS();
          units = act_units.map((item) => {
            return { value: item._id, label: item.unit };
          });
        }

        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";
        symptomForm = {
          name: action.val,
          sName: action.val,
          showName: action.val,
          scale: "",
          symptom: isContributedItem(state.symptomForm) && !action.crossClicked
            ? state.symptomForm.symptom
            : "",
          _id: "",
          comment: state.symptomForm.comment,
          category: state.symptomForm.category,
          time: action.time
            ? action.time
            : state.symptomForm.time
              ? state.symptomForm.time
              : moment(),
          unit:
            state.symptomForm.category === "01"
              ? "142"
              : isContributedItem(state.symptomForm) && state.unitOptions.length === 1
                ? state.unitOptions[0].value  // If contributed item with single unit, preserve autofilled unit
                : "",                         // Otherwise, clear selected unit
          users: state.symptomForm.users,
          upc: state.symptomForm.upc ? state.symptomForm.upc : "",
          vId: "",
        };
      }

      state.unitOptions =
        state.symptomForm.category === "01"
          ? []
          : isContributedItem(state.symptomForm)
            ? state.unitOptions  // Preserve unit options of contributed item when name changed without clicking X icon
            : handleUnitDropdown(state.symptomForm.category, { unit: [] }, true);

      state.symptomForm = symptomForm;

      if (action.crossClicked) {
        state.symptomForm.upc = "";
        state.unitOptions = [];
        state.symptomForm.units = [];
      }

      if (state.upc404 && !action.crossClicked) {
        state.symptomForm.upc = state.upc404Value;
      }
      if (action.contributeRedirectionAlert) {
        state.contributeRedirectionAlert = false;
      }

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      state.itemChanged = detectItemChanged(state.symptomForm, state.selectedItem);

      state.symptomFormPrevious = {}

      buttonsChecker();
      return {
        ...state,
        upc404: false,
        selectedNewTAS: true,
      };
    case SYMPTOM_DATE_CHANGED:
      state.symptomForm.time = action.val;

      // ❌ Do NOT set itemChanged = true here because if user revert time back to original, we're not handling itemchanged=false here. Forcing it to true here will lead to false positive
      // ❌ Do NOT set itemChanged = false here because there may be changes in other fields. Forcing it to false here will lead to false negative

      buttonsChecker();
      return { ...state };
    case SYMPTOM_KIT_SELECTED:
      let kitdata = action.item.items;
      state.symptomForm.unit = "";
      state.symptomForm.scale = "";
      state.amountReseter = !state.amountReseter;
      state.hhmmMode = false;

      state.outOfRange = false;
      kitdata = kitdata.map((item) => {
        return {
          name: item.fullname,
          fullname: item.fullname,
          symptom: item._id,
          sName: item.name,
          displayName: item.name,
          showName: item.name,
          scale: item.value,
          unitList: item.unit,
          unit: item.unitid || item.unit[0], // For mealset, get Unit for Display Area from "unitid". For other categories, use first index from "unit" as Unit for Display Area
          users: [],
          category: state.symptomForm.category,
          time: state.symptomForm.time,
          ingredients: item.ingredients_text ? item.ingredients_text : "",
          upc: item.upc,
        };
      });
      state.symptomForm.kitdata = kitdata;
      state.symptomForm.name = action.item.fullname;

      state.symptomForm.symptom = action.item._id;
      state.symptomForm.time = state.symptomForm.time || moment();
      state.itemChanged = detectItemChanged(state.symptomForm, state.selectedItem);

      buttonsChecker();
      return {
        ...state,
        nameOptions: [],
        selectedNewTAS: false,
        kitdata,
      };
    case SYMPTOM_KIT_ADD:
      // Step 1: Handle removing selected item from Display Area and replace with regimen content
      if (state.selectedItem && state.selectedItem.vId) {
        state.users.forEach((user) => {
          let deleteIndex = undefined;
          user.inputs &&
            user.inputs.map((input, i) => {
              if (input.vId == state.selectedItem.vId) {
                deleteIndex = i;
              }
            });
          if (deleteIndex != undefined) user.inputs.splice(deleteIndex, 1);
        });
        var showList = [];
        state.users.forEach((user) => {
          if (user.inputs && user.inputs.length > 0) {
            showList.push(user);
          }
        });
        state.showList = showList;
      }

      // Step 2: Prepare updated kit data
      kitdata = state.kitdata;
      kitdata = kitdata.map((item) => {
        return {
          ...item,
          time: state.symptomForm.time,
          comment: state.symptomForm.comment,
        };
      });

      let formUsers = state.symptomForm.users;

      formUsers.forEach((element) => {
        state.users.forEach((user) => {
          if (user._id == element) {
            kitdata.forEach((child) => {
              // Normalize raw unit & size from child
              const unitRaw = String(
                child.unitid ||
                (Array.isArray(child.unit) ? child.unit[0] : (child.unit || ""))
              );
              const sizeRaw = String(child.scale || child.value || "");

              // 1) Hours (102) → HH;MM for display IF decimal and >= 3h
              const disp = convertHHMMForDisplay(sizeRaw, unitRaw);

              let displayUnit   = unitRaw;
              let displayScale  = sizeRaw;
              let backendUnit   = unitRaw;
              let backendScale  = sizeRaw;

              if (disp.unit === "445") {
                // Convert to HH;MM for UI, keep original hours for payload
                displayUnit  = "445";
                displayScale = disp.display;
                backendUnit  = disp.backendUnit;   // "102"
                backendScale = disp.backendScale;  // decimal hours as string
              } else if (unitRaw === "445" && /[:;]/.test(sizeRaw)) {
                // 2) Already HH;MM → compute backend once
                // Only convert when the HH:MM unit is selected AND the value looks like HH;MM or HH:MM
                const conversionresult = convertHHMMForBackend(sizeRaw, unitRaw);
                backendUnit  = conversionresult.unit;
                backendScale = conversionresult.scale;
              }
              // 3) All other units → passthrough (backendUnit/backendScale already set before the if block)

              var insertItem = {
                ...child,
                vId: uuidv4(),
                users: [element],
                unitList: child.unitList, // Store dropdown unit options to be used later if user selects the item from Display Area
                unit: displayUnit, // For UI purpose
                scale: displayScale, // For UI purpose
                backendScale: backendScale, // Stored converted scale for Backend usage when user clicks Save Page
                backendUnit: backendUnit,   // Stored converted unit for Backend usage when user clicks Save Page
              };
              if (!user.inputs) user.inputs = [];
              user.inputs.push(insertItem);
            });
          }
        });
      });

      var showList = [];
      state.users.forEach((user) => {
        if (user.inputs && user.inputs.length > 0) {
          showList.push(user);
        }
      });
      symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: state.symptomForm.category,
        time: state.symptomForm.time,
        unit: "",
        users: state.symptomForm.users,
      };
      state.updateMode = false;
      state.selectedItem = {};
      state.kitdata = [];
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.symptomForm = symptomForm;
      state.showList = showList;
      state.itemChanged = false;

      buttonsChecker();
      return {
        ...state,
        nameOptions: [],
        kitModal: false,
        selectedNewTAS: false,
      };
    case SYMPTOM_OPTION_SELECTED:
      state.symptomFormPrevious = "";
      state.partialResult = [];
      let units = [];
      let scaleOptions = [];
      symptomForm = { ...state.symptomForm };

      symptomForm.name = "";
      symptomForm.symptom = action.item._id;
      symptomForm._id = action.item._id;
      symptomForm.unit = "";

      if (action.bodyMap) {
        symptomForm.category = "01";
        localStorage.removeItem("bodyMapSymptom");
      }

      // -------------------------------------------
      // TAS Name and Display Name Logic Starts Here
      // -------------------------------------------

      if (symptomForm.category == "02") {
        symptomForm.name = action.item.recipe_full;
        symptomForm.displayname = action.item.recipe;

        symptomForm.sName = state.barcodeScanned
          ? action.item.title
          : action.item.recipe_full;

        symptomForm.showName = action.item.recipe;

      } else if (symptomForm.category === "01") {
        symptomForm.name = state.barcodeScanned
          ? action.item.title
          : action.item.name;

        symptomForm.displayname = action.item.displayname;
        symptomForm.sName = state.barcodeScanned
          ? action.item.title
          : action.item.displayname;

        symptomForm.showName = state.barcodeScanned
          ? action.item.title
          : action.item.displayname;

      } else if (["03", "04", "05", "06", "07"].includes(symptomForm.category)) {
        symptomForm.sName = state.barcodeScanned
          ? action.item.title
          : action.item.fullname;

        symptomForm.name = action.item.fullname;
        symptomForm.displayname = action.item.name;
        symptomForm.showName = action.item.fullname;
      }

      // -------------------------------------------
      // TAS Name and Display Name Logic Ends Here
      // -------------------------------------------

      // Get ingredient info for Ingredient Icon
      if (action.item.ingredients_text) {
        symptomForm.ingredients = action.item.ingredients_text;
      }

      // Check if it's a contributed item and append UPC to the end of the item name field
      itemID = action.item._id;
      itemID = itemID.slice(0, 1);

      if (itemID != 1 && action.item.upc) {
        symptomForm.upc = action.item.upc;
      }

      // --------------------------------------------------------------------
      // New Clean Logic for Unit and Scale (Severity Dropdown) - Starts here
      // --------------------------------------------------------------------
      const unitOptions = handleUnitDropdown(symptomForm.category, action.item); // Get unit dropdown values from helper function
      state.unitOptions = unitOptions;
      symptomForm.unitList = action.item.units || action.item.unit || action.item.unitsid || [];

      if (unitOptions.length === 1) {
        symptomForm.unit = unitOptions[0].value;
      }

      // Special handling for Symptom category (Severity Dropdown)
      if (symptomForm.category === "01" && unitOptions.length === 1) {
        const selectedUnitId = unitOptions[0].value;
        const symptomUnits = SYMPTOM_UNITS_NEW();
        const matchedUnit = symptomUnits.find(u => u._id === selectedUnitId);
        if (matchedUnit && matchedUnit.label) {
          scaleOptions = matchedUnit.label.map((label, index) => ({
            value: matchedUnit.value[index],
            label
          }));
        } else if (matchedUnit && matchedUnit.description) {
          scaleOptions = [];
          scaleOptions.desc = matchedUnit.description;
        }
      }
      
      symptomForm.scale = "";
      symptomForm.time = action.time ? action.time : state.symptomForm.time ? state.symptomForm.time : moment(),
      state.amounNewValue = "";
      state.amountReseter = !state.amountReseter;
      state.hhmmMode = false;

      state.symptomForm = symptomForm;

      buttonsChecker();

      return {
        ...state,
        symptomForm,
        scaleOptions,
        selectedNewTAS: true,
        barcodeScanned: false,
      };
    case getStarted(CREATE_SYMPTOM):
      return { ...state, isLoading: true };

    case getFailed(CREATE_SYMPTOM):
      return { ...state, isLoading: false };

    case getSucceeded(CREATE_SYMPTOM):
      symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: "",
        time: moment(),
        unit: "",
        users: state.symptomForm.users,
      };
      data = state.users.map((item) => {
        return item;
      });
      return { ...state, isLoading: false, symptomForm: symptomForm };
    case INPUT_ADD_ITEM:
      // Safety Check: Normalize users to always be a flat array
      if (action.item && action.item.users) {
        if (!Array.isArray(action.item.users)) {
          action.item.users = action.item.users._id ? [action.item.users._id] : [];
        } else if (
          Array.isArray(action.item.users) &&
          action.item.users.length === 1 &&
          Array.isArray(action.item.users[0])
        ) {
          // Handle nested array like [['u1', 'u2']]
          action.item.users = action.item.users[0];
        }
      }

      let displayName = action.displayName
        ? action.displayName
        : state.symptomForm.showName;

      state.itemInVerAutofill = false;
      if (!action.item) {
        action.item = state.symptomForm;
      }

      // Determine whether it's custom or RefDB
      const isCustom =
        (!action.item.symptom || action.item.symptom.length === 0) &&
        (!action.item.upc || action.item.upc.length === 0);

      action.item.name = action.item.name.replace(/\s+/g, " ").trim();

      if (isCustom) {
        const CaseInsensitiveName = action.item.name.toLowerCase();

        if (CaseInsensitiveName.endsWith(" (c)")) {
          // If ends with " (C)", remove the space before (C)
          action.item.name = action.item.name.slice(0, -4) + " (C)";
        } else if (CaseInsensitiveName.endsWith("(c)")) {
          // if there's "(C)", just remove and add back. This handles the case of switching lower case "(c)" adding by user (if any) to the standard upper case "(C)"
          action.item.name = action.item.name.slice(0, -3) + " (C)";
        } else if (!CaseInsensitiveName.endsWith("(c)")) {
          // If there's no "(C)", append "(C)"
          action.item.name += " (C)";
        }
        action.item.sName = action.item.name;
        action.item.displayname = action.item.name;
        action.item.showName = action.item.name;
        action.item.displayName = action.item.name;

      } else {
        // ✅ For RefDB items, derive showName safely
        if (!action.item.displayname || action.item.displayname.trim() === "") {
          action.item.displayname = action.item.recipe || action.item.name;
        }
        action.item.showName = action.item.displayname;
      }

      action.item.users.forEach((element) => {
        state.users.forEach((user) => {
          if (user._id == element) {
            var insertItem = {
              ...action.item,
              name: action.item.recipe_full || action.item.fullname || action.item.name,
              displayname: action.item.displayname,
              vId: uuidv4(),
              users: [element],
              selected: false,
              unitOptions: state.unitOptions, // Store dropdown unit options to be used later if user selects the item from Display Area
              backendScale: action.item.backendScale, // Stored converted scale for Backend usage when user clicks Save Page
              backendUnit: action.item.backendUnit, // Stored converted unit for Backend usage when user clicks Save Page
            };

            if (user.inputs) {
              user.inputs = [...user.inputs, insertItem];
            } else {
              user.inputs = [insertItem];
            }
          }
        });
      });
      var showList = [];
      state.users.forEach((user) => {
        if (user.inputs && user.inputs.length > 0) {
          showList.push(user);
        }
      });
      symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: state.symptomForm.category,
        time: state.symptomForm.time ? state.symptomForm.time : "",
        unit: "",
        users: state.symptomForm.users,
      };
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.symptomForm = symptomForm;
      state.showList = showList;
      state.scaleOptions = []; // Need to clear to remove the caret down symbol from severity field after deselecting or clicking cancel update

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      // Sort each user's inputs after adding new item to make sure items are always stored in chronological order even after returning from Contribute Page. In the future, need to restructure the same way as Body Map redirection (store in redux rather than local storage contDefault)
      state.showList = state.showList.map(user => {
        if (user.inputs && Array.isArray(user.inputs)) {
          user.inputs = user.inputs.map(item => ({
            ...item,
            time: moment(item.time),
          }));

          user.inputs = _.orderBy(user.inputs, ["time"], ["asc"]);
        }
        return user;
      });

      state.outOfRange = false;
      buttonsChecker();
      return {
        ...state,
        nameOptions: [],
        unitOptions: [],
        selectedNewTAS: false,
      };
    case getStarted(SAVE_FOOD_AND_SYMPTOMS):
      return { 
        ...state, 
        isLoading: true, 
        saveError: { type: null, meta: [] }, 
      };
    case SAVE_FOOD_AND_SYMPTOMS:
      localStorage.removeItem("contDefault"); // Clear after clicking Save Page to prevent the data in contDefault being autofilled again after succesffully saving the data
      data = state.users.map((item) => {
        delete item.inputs;
        return item;
      });
      state.symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: "",
        time: moment(),
        unit: "",
        users: state.symptomForm.users,
      };
      state.isLoading = false;
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.users = data;
      state.showList = [];

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      state.selectedIndexList = [];

      const hasNewTrend = action.data && action.data.trend_alert === true;

      // Only auto-redirect if we do NOT need to show the YYY prompt
      if (!hasNewTrend) {
        setTimeout(() => {
          window.location.href = `/symptom`;
        }, 1000);
      }

      buttonsChecker();
      return {
        ...state,
        saveSuccess: true,             // always show success modal first
        NewTrendFound: !!hasNewTrend,  // when TFI is true, remember Trend Alert is needed
        selectedNewTAS: false,
      };

    case getFailed(SAVE_FOOD_AND_SYMPTOMS): {
      const { message, meta } = action.error || {};

      let type = null;
      if (message === "name already exists") {
        type = "alreadyUsedRecipeName";
      }

      // 🔑 normalize meta to string[]
      const normalizedMeta = Array.isArray(meta)
        ? meta
            .map(m =>
              typeof m === "string"
                ? m
                : (m && m.name) || (m && m.label) || ""
            )
            .filter(Boolean)
        : [];

      return {
        ...state,
        isLoading: false,
        saveError: {
          type,
          meta: normalizedMeta,
        },
      };
    }

    case SYMPTOMS_ITEM_SELECT:
      state.symptomFormPrevious = "";
      let userBeforeSelect = null;

      // ✅ Prioritize userBeforeDelete if present (only for delete flow)
      if (state.userBeforeDelete) {
        userBeforeSelect = [...state.userBeforeDelete];
        delete state.userBeforeDelete; // use once then clear
      } // Handle user selection for both object and array
      else if (Array.isArray(action.user)) {
        const filtered = action.user.filter(Boolean); // removes null/undefined
        userBeforeSelect = filtered.map(u => (typeof u === 'object' ? u._id : u));
        state.symptomForm.users = userBeforeSelect;
        state.users = state.users.map(user => ({
          ...user,
          isSelected: userBeforeSelect.includes(user._id),
        }));
      } else if (action.user && action.user._id) {
        userBeforeSelect = action.user._id;
        userSelected(userBeforeSelect, true);
      }

      let clickedItem = undefined;

      let selectedCategory = state.selectedItem.category || state.symptomForm.category;
      state.users.forEach((user) => {
        if (user.inputs) {
          user.inputs.forEach((input) => {
            if (input.vId == action.vId) {
              input.selected = !input.selected;
              if (input.selected) {
                clickedItem = { ...input, users: [user._id] };
              }
            } else {
              input.selected = false;
            }
          });
        }
      });

      var showList = state.users.filter((user) => user.inputs && user.inputs.length > 0);

      // If item selected fro Display Area
      if (clickedItem) {
        const isCustom = !clickedItem.symptom && !clickedItem.upc;

        symptomForm = {
          vId: clickedItem.vId,
          _id: clickedItem._id,
          name: isCustom
            ? clickedItem.name
            : clickedItem.recipe_full || clickedItem.name || clickedItem.displayName,
          scale: clickedItem.scale,
          symptom: clickedItem.symptom,
          type: "",
          category: clickedItem.category,
          time: clickedItem.time ? moment(clickedItem.time) : "",
          comment: clickedItem.comment || "",
          unit: clickedItem.unit,
          units: clickedItem.units,
          sName: clickedItem.sName,
          unitList: [],
          users: Array.isArray(clickedItem.users) ? clickedItem.users : [clickedItem.users],
          displayname: clickedItem.displayname,
          showName: clickedItem.showName,
          upc: clickedItem.upc || "",
          ingredients: clickedItem.ingredients || undefined,
        };

        // --------------------------------------------------------------------
        // New Clean Logic for Unit and Scale (Severity Dropdown) - Starts here
        // --------------------------------------------------------------------
        // Centralized unit logic using handleUnitDropdown
        let unitOptions = clickedItem.unitOptions || handleUnitDropdown(symptomForm.category, clickedItem);

        // For item select, show selected unit from Display Area if multiple
        if (unitOptions.length > 1 && clickedItem.unit) {
          symptomForm.unit = clickedItem.unit;
        } else if (unitOptions.length === 1) {
          symptomForm.unit = unitOptions[0].value;
        }

        state.unitOptions = unitOptions;

        // 🕒 Auto-enable HH:MM Mode if unit is 445
        const isHHMMUnit = symptomForm.unit === "445" || symptomForm.unit === 445;

        if (isHHMMUnit && !state.hhmmMode) {
          state.hhmmMode = true;
          state.amountReseter = !state.amountReseter;
        } else if (!isHHMMUnit && state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter;
        }

        // Special handling for Symptom category (Severity Dropdown)
        let scaleOptions = [];
        if (symptomForm.category === "01") {
          const symptomUnits = SYMPTOM_UNITS_NEW();
          const matchedUnit = symptomUnits.find(u => u._id === symptomForm.unit);

          if (matchedUnit && matchedUnit.label) {
            scaleOptions = matchedUnit.label.map((label, index) => ({
              value: matchedUnit.value[index],
              label
            }));
          } else if (matchedUnit && matchedUnit.description) {
            scaleOptions = [];
            scaleOptions.desc = matchedUnit.description;
          }
        }
        state.scaleOptions = scaleOptions;
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = clickedItem.scale;
        state.symptomForm = symptomForm;
        state.selectedItem = {
          id: clickedItem.symptom,
          vId: clickedItem.vId,
          name: clickedItem.name,
          scale: clickedItem.scale,
          symptom: clickedItem.symptom,
          type: "",
          category: clickedItem.category,
          time: clickedItem.time ? moment(clickedItem.time) : "",
          comment: symptomForm.comment,
          unit: clickedItem.unit,
          users: Array.isArray(clickedItem.users) ? clickedItem.users : [clickedItem.users],
          completeItem: action.user,
          displayname: clickedItem.displayname,
          showName: clickedItem.showName,
          upc: clickedItem.upc || ""
        };
        state.cancelMode = true;
        state.updateMode = false;
        state.itemChanged = false; // Very important here!

        // No item selected from Display Area  
      } else {
        symptomForm = {
          name: "",
          scale: "",
          symptom: "",
          type: "",
          category: selectedCategory,
          time: "",
          unit: "",
          users: Array.isArray(userBeforeSelect) ? userBeforeSelect : [userBeforeSelect],
          comment: "",
        };

        // ✅ FIX: Restore users in each input after Cancel Update
        // When you click Cancel Update, you're essentially deselecting a selected item.
        // That triggers the SYMPTOMS_ITEM_SELECT reducer's else block (the deselection path).
        // In that block, we clear the selected item and rebuild the form.
        // During the rebuild, ensure that every input in Display Area is always linked to a user, even after deselecting or cancel update?
        // Without the logic block below, each input will no longer have user info if pass through else block by clicking on Cancel Update. This will lead to "Failed to Save"
        state.users.forEach((user) => {
          if (user.inputs) {
            user.inputs.forEach((input) => {
              if (!input.users || input.users.length === 0) {
                input.users = [user._id]; // reassign user to input
              }
            });
          }
        });

        state.symptomForm = symptomForm;
        state.selectedItem = {};
        state.unitOptions = [];
        state.scaleOptions = []; // Need to clear to remove the caret down symbol from severity field after deselecting or clicking cancel update
        state.amounNewValue = "";
        state.amountReseter = !state.amountReseter;
        state.cancelMode = false;
        state.updateMode = false;
        // state.disabled.addBtn = true;
        state.outOfRange = false;
        state.itemChanged = false;
        if (state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter;
        }

      }
      state.amountReseter = !state.amountReseter;

      buttonsChecker();

      state.showList = showList;

      return {
        ...state,
        selectedNewTAS: false,
      };
    case SYMPTOMS_ITEM_DELETE:
      const userBeforeDelete = state.users
        .filter(user => user.isSelected)
        .map(user => user._id);

      state.selectedItem = {};

      state.users.forEach((user) => {
        let deleteIndex = undefined;

        user.inputs &&
          user.inputs.map((input, i) => {
            if (input.vId == action.vId) {
              deleteIndex = i;
            }
            input.selected = false;
            clickedItem = undefined;
            state.updateMode = false;
          });
        if (deleteIndex != undefined) user.inputs.splice(deleteIndex, 1);
      });

      var showList = state.users.filter(
        (user) => user.inputs && user.inputs.length > 0
      );
      state.showList = showList;
      state.updateMode = false;

      var symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: "",
        time: moment(),
        unit: "",
        _id: "",
        users: userBeforeDelete,
        comment: "",
      };
      state.unitOptions = [];
      state.symptomForm = symptomForm;
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      state.userBeforeDelete = [...userBeforeDelete];

      buttonsChecker();

      state.users.forEach((u) => {
      });

      return { ...state, selectedNewTAS: false };
    case SYMPTOMS_ITEM_UPDATE:
      let showName = action.displayName;

      state.duplicate = false;
      state.users.map((inputUser) => {
        state.showList.map((user) => {
          user.inputs.map((item) => {
            if (item.name === state.symptomForm.name) {
              state.duplicate = true;
            }
          });
        });
      });

      const isCustomUpdate =
        (!state.symptomForm.symptom || state.symptomForm.symptom.length === 0) &&
        (!state.symptomForm.upc || state.symptomForm.upc.length === 0);

      state.symptomForm.name = state.symptomForm.name.replace(/\s+/g, " ").trim(); // Remove double space and trailing space

      if (isCustomUpdate) {
        const CaseInsensitiveName = state.symptomForm.name.toLowerCase();

        if (CaseInsensitiveName.endsWith(" (c)")) {
          // If ends with " (C)", remove the space before (C)
          state.symptomForm.name = state.symptomForm.name.slice(0, -4) + " (C)";
        } else if (CaseInsensitiveName.endsWith("(c)")) {
          // if there's "(C)", just remove and add back. This handles the case of switching lower case "(c)" adding by user (if any) to the standard upper case "(C)"
          state.symptomForm.name = state.symptomForm.name.slice(0, -3) + " (C)";
        } else if (!CaseInsensitiveName.endsWith("(c)")) {
          // If there's no "(C)", append "(C)"
          state.symptomForm.name += " (C)";
        }
        state.symptomForm.sName = state.symptomForm.name;
        state.symptomForm.displayname = state.symptomForm.name;
        state.symptomForm.showName = state.symptomForm.name;
        state.symptomForm.displayName = state.symptomForm.name;
      } else {
        // Ensure displayname is safely derived
        if (!state.symptomForm.displayname || state.symptomForm.displayname.trim() === "") {
          state.symptomForm.displayname = state.symptomForm.recipe || state.symptomForm.sName || state.symptomForm.name;
        }
        state.symptomForm.showName = state.symptomForm.displayname;
      }

      state.users.forEach((user) => {
        let updateIndex = undefined;
        user.inputs &&
          user.inputs.map((input, i) => {
            if (input.vId == state.selectedItem.vId) {
              updateIndex = i;
            }
          });
        if (updateIndex != undefined)
          user.inputs[updateIndex] = {
            ...state.symptomForm,
            name: state.symptomForm.recipe_full || state.symptomForm.fullname || state.symptomForm.name,
            users: [user._id],
            vId: state.selectedItem.vId,
            unitOptions: state.unitOptions, // Store dropdown unit options to be used later if user selects the item from Display Area
            backendScale: state.symptomForm.backendScale, // Stored converted scale for Backend usage when user clicks Save Page
            backendUnit: state.symptomForm.backendUnit,   // Stored converted unit for Backend usage when user clicks Save Page
          };
      });

      var symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: state.symptomForm.category,
        time: state.symptomForm.time ? state.symptomForm.time : "",
        unit: "",
        users: state.symptomForm.users,
      };
      state.selectedItem = {};
      state.symptomForm = symptomForm;
      state.itemChanged = false;

      var showList = [];
      state.users.forEach((user) => {
        if (user.inputs && user.inputs.length > 0) {
          showList.push(user);
        }
      });
      state.showList = showList;

      // Sort each user's inputs after updating an item to make sure items are always stored in chronological order even after returning from Contribute Page. In the future, need to restructure the same way as Body Map redirection (store in redux rather than local storage contDefault)
      state.showList = state.showList.map(user => {
        if (user.inputs && Array.isArray(user.inputs)) {
          user.inputs = user.inputs.map(item => ({
            ...item,
            time: moment(item.time),
          }));

          user.inputs = _.orderBy(user.inputs, ["time"], ["asc"]);
        }
        return user;
      });
      state.outOfRange = false;
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.cancelMode = false;
      state.updateMode = false;
      state.disabled.addBtn = true;
      state.scaleOptions = []; // Need to clear to remove the caret down symbol from severity field after deselecting or clicking cancel update

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();

      return { ...state, selectedNewTAS: false, unitOptions: [], };

    case UPDATE_ITEM_CANCELED:
      var clickedItem;
      var clickeduser = [];
      state.showList.forEach((user) => {
        user.inputs.map((input) => {
          input.users = clickeduser;
          if (input.vId == action.vId) {
            input.selected = !input.selected;
            if (input.selected) {
              clickedItem = input;
              state.updateMode = true;
            } else {
              clickedItem = undefined;
              state.updateMode = false;
            }
          } else {
            input.selected = false;
          }
        });
      });
      state.users.forEach((user) => {
        if (user.isSelected) {
          user.inputs.map((input) => {
            input.users = clickeduser;
            if (input.vId == action.vId) {
              input.selected = !input.selected;
              if (input.selected) {
                clickedItem = input;
                state.updateMode = true;
              } else {
                clickedItem = undefined;
                state.updateMode = false;
              }
            } else {
              input.selected = false;
            }
          });
        }
      });
      symptomForm = {
        name: "",
        scale: "",
        symptom: "",
        type: "",
        category: selectedCategory,
        time: "",
        unit: "",
        users: state.symptomForm.users,
        comment: "",
      };
      state.unitOptions = []; // important to clear and reset Unit to default for single unit items
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.symptomForm = symptomForm;
      // state.selectedItem = {}; // DO NOT clear state.selectedItem here. selectItemPos() will dispatch SYMPTOMS_ITEM_SELECT after this and needs selectedItem.category to clear neatly
      state.cancelMode = false;
      state.updateMode = false;
      state.disabled.addBtn = true;
      state.outOfRange = false;
      state.itemChanged = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();

      return { ...state, isLoading: false };


    case RESET_INPUT_PAGE:
      state = initialState;

      buttonsChecker();
      return { ...state };
    case 'RESET_ITEM_CHANGED':
      return {
        ...state,
        itemChanged: false
      };
    case RESET_CONTRIBUTE_ALERT_STATE:
      state.contributeRedirectionAlert = false;
      state.upc404 = false;
      return { ...state };
    case SET_HHMM_MODE:
      state.hhmmMode = action.value;
      return {
        ...state,
      };
    case ADD_GREY_UPC_ITEM_NAME_FIELD:
      state.symptomForm = {
        ...state.symptomForm,
        upc: action.payload,
      };
      return { ...state };
    case getStarted(SYMPTOM_FROM_BODYMAP):
      return { ...state, isLoading: true };
    case getSucceeded(SYMPTOM_FROM_BODYMAP):
      let cancelOrNot = localStorage.getItem("bodyMapSymptom");

      if (cancelOrNot && cancelOrNot !== "cancel") {
        cancelOrNot = JSON.parse(cancelOrNot);
      }

      let symptomFormData = JSON.parse(localStorage.getItem("symptomForm"));
      let showList = JSON.parse(localStorage.getItem("showList")) || [];
      let defaultTime;
      if (showList && showList.length > 0) {
        showList = showList.map((item) => {
          if (item.isSelected) {
            state.symptomForm.users = _.union(
              [item._id],
              state.symptomForm.users
            );
          }
          item.inputs.map((e) => {
            if (e.selected) {
              state.updateMode = true;
              state.selectedItem = e;
              state.symptomForm.vId = e.vId;
            }

            e.time = moment(e.time);
            return e;
          });
          state.users.map((user) => {
            if (user._id === item._id) {
              user.inputs = item.inputs;
              user.isSelected = item.isSelected;
            }
            return user;
          });
          return item;
        });
        state.showList = showList;
      }
      if (symptomFormData) {
        symptomFormData.users.map((item) => {
          state.users.map((user) => {
            if (user._id === item) {
              user.isSelected = true;
            }
            return user;
          });
        });

        state.symptomForm.users = symptomFormData.users;
        state.symptomForm.category = symptomFormData.category;
        state.symptomForm.time = symptomFormData.time
          ? moment(symptomFormData.time)
          : cancelOrNot.time
            ? moment()
            : "";
        defaultTime = symptomFormData.time
          ? moment(symptomFormData.time)
          : cancelOrNot.time
            ? moment()
            : "";
        state.symptomForm.comment = symptomFormData.comment;
      }
      buttonsChecker();
      localStorage.removeItem("symptomForm");
      localStorage.removeItem("showList");
      state.symptomForm.time = defaultTime && defaultTime;
      return { ...state, counterState: state.counterState + 1 };
    case getEnded(SYMPTOM_FROM_BODYMAP):
      return { ...state, isLoading: false };
    case getStarted(BARCODE_READ):
      state.itemInVerAutofill = false;
      state.partialResult = [];
      buttonsChecker();
      return {
        ...state,
        isLoading: true,
        upc404: false,
        barcodeCategoryRef: false,
        incorrectBarcodeCategory: false,
        itemInVerAutofill: false,
        amountReseter: !state.amountReseter,
      };
    case getSucceeded(BARCODE_READ):
      console.log("STARTED")
      console.log("itemInVerAutofill", state.itemInVerAutofill)
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.kitdata = [];
      symptomForm = {
        ...state.symptomForm,
        name: "",
        sName: "",
        scale: "",
        symptom: "",
        kitdata: {},
        comment: state.symptomForm.comment,
        category: action.data.category,
        users: state.symptomForm.users,
        unit: "",
      };

      const {
        category,
        is_ref,
        is_own,
        is_history,
        upc,
        number_of_contribute,
        show_prompt,
      } = action.data;

      state.amountReseter = !state.amountReseter;
      state.unitOptions = [];
      const updateSymptomForm = (data, forcedCategory) => {
        console.log("state.symptomForm.category", state.symptomForm.category)
        console.log("forcedCategory", forcedCategory)
        console.log("data.category", data.category)

        const cat = forcedCategory || data.category;
        state.symptomForm = {
          ...state.symptomForm,
          name: data.recipe_full || data.fullname || data.name,
          sName: data.recipe || data.displayname || data.name,
          recipe_full: data.recipe_full || data.title,
          recipes: data.name || data.title,
          recipe: data.name || data.title,
          full_name: data.fullname || data.title,
          fullname: data.fullname || data.title,
          displayname: data.name || data.recipe || data.title,
          upc: !is_ref && upc,
          scale: "",
          _id: data._id,
          symptom: data._id,
          category: cat,
          units: data.units,
        };
        if (data.unitid) {
          state.symptomForm.unit = data.unitid;
        }
        state.unitOptions = handleUnitDropdown(
          state.symptomForm.category,
          action.data
        );
        if (action.data.units.length === 1 && action.data.units[0] !== "910") {
          state.symptomForm.unit = state.unitOptions[0].value;
        }
      };


      // -------- Non-RefDB ITEM --------
      if (!is_ref) {
        // -------- Item in Verification/Incorrect Category/Incompatible Category --------
        if (show_prompt && number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && category !== state.symptomForm.category) {
              // own → incorrect category first
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true;
              
              state.showVerificationPrompt = true; // flag to trigger Item in Verification upon positive action
            } else {
              state.itemInVerAutofill = true;
              state.itemData = action.data;
            }
          }

          // -------- history = true --------
          else {
            if (category !== state.symptomForm.category) {
              // mismatch → incompatible category first
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
              
              state.showVerificationPrompt = true; // flag to trigger Item in Verification upon positive action
            } else {
              state.itemInVerAutofill = true;  
              state.itemData = action.data;          
            }
          }
        }

        // -------- Incorrect Category/Incompatible Category --------
        else if (number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && category !== state.symptomForm.category) {
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true
            } else {
              updateSymptomForm(action.data, state.symptomForm.category);
            }
          }

          // -------- history = true --------
          else {
            if (category !== state.symptomForm.category) {
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
            } else {
              updateSymptomForm(action.data);
            }
          }
        }

        // -------- Product not in 12u12 DB/Incorrect Category/Incompatible Category --------
        else if (number_of_contribute < 4) {
          // -------- history = false --------
          if (!is_history) {
            if (!is_own) {
              state.contributeRedirectionAlert = true;
              state.upc404 = true;
              let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
                returnObjects: true,
              });
              state.listings = Object.entries(listingObject).map(([key, value]) => ({
                key,
                value,
              }));
              state.upc404Value = action.data.upc;
            } else if (category !== state.symptomForm.category) {
              state.incorrectBarcodeCategory = true;
              state.itemData = action.data;
              // state.itemData.setRef = true
            } else {
              updateSymptomForm(action.data);
            }
          }

          // -------- history = true --------
          else {
            if (category !== state.symptomForm.category) {
              state.barcodeCategoryRef = true;
              state.refdb_item = false;
              const categories = i18n.t("CATEGORIES", { returnObjects: true });
              let categoryItem = categories.find((item) => item.value === category);
              state.refdb_item_category = categoryItem ? categoryItem.label : "";
              state.itemData = action.data;
              // state.itemData.setRef = true;
            } else {
              updateSymptomForm(action.data);
            }
          }
        }
      } 
      
      // -------- RefDB ITEM --------
      else {
        if (category !== state.symptomForm.category) {
          state.barcodeCategoryRef = true;
          state.refdb_item = true;
          const categories = i18n.t("CATEGORIES", { returnObjects: true });
          let categoryItem = categories.find((item) => item.value === category);
          state.refdb_item_category = categoryItem ? categoryItem.label : "";
          state.itemData = action.data;
        } else {
          action.data.upc = "";
          updateSymptomForm(action.data);
          state.barcodeRead = true;
        }
      }


      // if (
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   (!is_own || is_own) &&
      //   (!is_history || is_history) &&
      //   show_prompt
      // ) {
      //   state.itemInVerAutofill = true;
      //   state.itemData = action.data;
      // } else if (
      //   number_of_contribute < 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   !show_prompt
      // ) {
      //   state.contributeRedirectionAlert = true;
      //   state.upc404 = true;
      //   let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
      //     returnObjects: true,
      //   });
      //   state.listings = Object.entries(listingObject).map(([key, value]) => ({
      //     key,
      //     value,
      //   }));
      //   state.upc404Value = action.data.upc;
      // } else if (
      //   number_of_contribute >= 4 &&
      //   !is_ref &&
      //   !is_own &&
      //   !is_history &&
      //   !show_prompt
      // ) {
      // } else if (category === state.symptomForm.category) {
      //   if (is_ref) {
      //     action.data.upc = "";
      //     updateSymptomForm(action.data);
      //     state.barcodeRead = true;
      //   } else if (is_own && !show_prompt) {
      //     updateSymptomForm(action.data);
      //   } else if (!is_ref && is_history) {
      //     updateSymptomForm(action.data);
      //   } else if (number_of_contribute >= 4 && show_prompt) {
      //     state.itemInVerAutofill = true;
      //     state.itemData = action.data;
      //   }
      // } else {
      //   if (is_ref) {
      //     state.barcodeCategoryRef = true;
      //     state.refdb_item = true;
      //     const categories = i18n.t("CATEGORIES", { returnObjects: true });
      //     let categoryItem = categories.find((item) => item.value === category);
      //     state.refdb_item_category = categoryItem ? categoryItem.label : "";
      //     state.itemData = action.data;
      //   } else if (is_history) {
      //     state.barcodeCategoryRef = true;
      //     state.refdb_item = false;
      //     const categories = i18n.t("CATEGORIES", { returnObjects: true });
      //     let categoryItem = categories.find((item) => item.value === category);
      //     state.refdb_item_category = categoryItem ? categoryItem.label : "";
      //     state.itemData = action.data;
      //     state.itemData.setRef = true;
      //   } else if (is_own) {
      //     state.incorrectBarcodeCategory = true;
      //     state.itemData = action.data;
      //     state.itemData.setRef = true;
      //   }
      // }
      state.barcodeScanned = true;
      state.symptomForm.time = state.symptomForm.time
        ? state.symptomForm.time
        : moment();

      buttonsChecker();
      return { ...state };
    case getFailed(BARCODE_READ):
      state.upc404Value = action.upc;
      state.category404Value = action.val;
      state.contributeRedirectionAlert = true;
      let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
        returnObjects: true,
      });
      state.listings = Object.entries(listingObject).map(([key, value]) => ({
        key,
        value,
      }));
      buttonsChecker();
      return { ...state, isLoading: false, upc404: true };
    case getEnded(BARCODE_READ):
      buttonsChecker();
      return { ...state, isLoading: false };
    case getStarted(BARCODE_READ_IMG):
      state.itemInVerAutofill = false;
      return { ...state, barcodeFailed: false, isLoading: true };
    case getSucceeded(BARCODE_READ_IMG):
      return { ...state, isLoading: false };
    case getFailed(BARCODE_READ_IMG):
      return { ...state, barcodeFailed: true, isLoading: false };

    case getSucceeded(PARTIAL_RESULT_FOUND):
      let getResult = action.partialSearch;
      return {
        ...state,
        partialResult: getResult,
      };
    case getFailed(PARTIAL_RESULT_FOUND):
      return {
        ...state,
        barcodeValue: action.upc,
        addCustomAlert: true,
      };
    case ON_CHANGE_ALERT_STATUS:
      state.addCustomAlert = !!action.data.addCustomAlert;
      return {
        ...state,
        ...action.data,
      };

    case HISTORY_SUGGESTIONS_STARTED:
      return { ...state, isLoading: true };

    case HISTORY_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        nameOptions: action.payload.show,
        nameTotalOptions: action.payload.data,
      };

    case HISTORY_SUGGESTIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        nameOptions: [],
        nameTotalOptions: [],
      };

    case HISTORY_SUGGESTIONS_CLEAR:
      return { 
        ...state, 
        nameOptions: [], 
        nameTotalOptions: [], 
        partialResult: [],     // <-- whatever backs props.partialResult
        // showList: [],          // <-- add if your mapping uses showList under the hood
        // showPartial: false,    // <-- drop any “partial is visible” flag you keep
      };

    case DISMISS_SAVE_SUCCESS:
      return { ...state, saveSuccess: false }; // keep NewTrendFound as-is

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/symptomReducer.js